import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { getClientContext } from '../utils/get-client-context';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);

    if (error instanceof HttpErrorResponse) {
      return;
    }

    Sentry.withScope((scope) => {
      scope.setContext('client', getClientContext());
      Sentry.captureException(error);
    });
  }
}
